import focusIndicator from './focusIndicator'
import instantSearch from './instantSearch'
import internetExplorerFixes from './internetExplorerFixes'
import overflowedToplistLinks, { collapseSupportLinks } from './overflowedToplistLinks'
import { widget } from './widget'
import { lightboxModal, contactModal } from './Modal'
import '../sass/knowledge.scss'
import errorMessage from './errorMessage'

if (!window.Promise) {
  window.Promise = Promise
}

function searchForm(rootElement) {
  const searchFormElement = rootElement.querySelector('.fn-search-form')
  const input = searchFormElement.querySelector('.fn-search-form__input')

  input.setAttribute('role', 'combobox')
  input.setAttribute('aria-autocomplete', 'list')
  input.setAttribute('aria-expanded', 'false')
  input.setAttribute('aria-controls', 'search-listbox')
  input.setAttribute('aria-haspopup', 'listbox')

  if (searchFormElement && input) {
    searchFormElement.addEventListener('submit', (event) => {
      if (!input.value.trim()) {
        event.preventDefault()
        input.focus()
      }
    })
  }

  if (input) {
    const placeholderText = input.getAttribute('placeholder')

    input.addEventListener('focus', () => {
      input.setAttribute('placeholder', '')
    })

    input.addEventListener('blur', () => {
      input.setAttribute('placeholder', placeholderText)
    })

    input.addEventListener('input', () => {
      if (input.value) {
        input.classList.add('search-form__input--has-value')
      } else {
        input.classList.remove('search-form__input--has-value')
      }
    })
  }
}

function voteButtons(rootElement, fetchBaseUrl) {
  rootElement.querySelectorAll('.helpful__button').forEach((feedbackButton) => {
    feedbackButton.addEventListener('click', () => {
      if (!rootElement.querySelector('.helpful__question').classList.contains('helpful__question--voted')) {
        fetch(`${fetchBaseUrl}${feedbackButton.getAttribute('data-to')}`, {
          method: feedbackButton.getAttribute('data-method'),
          credentials: 'include',
        })
          .then((response) => {
            if (response.ok) {
              feedbackButton.classList.add('helpful__button--selected')
              feedbackButton.setAttribute('aria-pressed', 'true')
              rootElement.querySelector('.helpful__question').classList.add('helpful__question--voted')

              const helpfulResponse = rootElement.getElementById(feedbackButton.getAttribute('data-onvote-id'))

              helpfulResponse.classList.add('helpful__response--selected')
              helpfulResponse.setAttribute('aria-hidden', 'false')
              const helpfulResponseElementHeight = helpfulResponse.getBoundingClientRect().height
              helpfulResponse.classList.add('helpful__response--expanding')
              helpfulResponse.style.height = '0'

              window.setTimeout(() => {
                helpfulResponse.addEventListener('transitionend', (event) => {
                  if (event.propertyName === 'height') {
                    helpfulResponse.classList.remove('helpful__response--expanding')
                    helpfulResponse.style.height = ''
                    helpfulResponse.style.top = ''
                  }
                })

                helpfulResponse.style.height = `${helpfulResponseElementHeight}px`
                helpfulResponse.style.top = '0'
              }, 20)

              const votedFor = feedbackButton.classList.contains("helpful__button--yes") ? "yes" : "no"
              document.dispatchEvent(
                new CustomEvent('kundo-knowledge:guide-voted', {
                  detail: {
                    helpful: votedFor
                  },
                  bubbles: true,
                  cancelable: true,
                  composed: true,
                }),
              )
            } else {
              throw new Error()
            }
          })
          .catch(() => {
            errorMessage('Tekniskt fel, det gick tyvärr inte att ge feedback just nu', { element: rootElement.querySelector('.helpful__question'), position: 'afterend' })
          })
      }
    })
  })
}

function kundoChat() {
  function handleChatStatus(evt) {
    const { flow } = evt.detail
    const chatStatusFlows = document.querySelectorAll(`.chat-status-${flow}`)
    chatStatusFlows.forEach((elm) => {
      const openLabel = elm.attributes['data-open-label'].value
      if (evt.type === 'kundo-chat:flow-available') {
        elm.innerText = openLabel
        elm.parentElement.classList.remove('contact-channels__channel-link--disabled')
      } else {
        elm.innerText = window.TRANSLATIONS.chatClosed
        elm.parentElement.classList.add('contact-channels__channel-link--disabled')
      }
    })
  }
  document.addEventListener('kundo-chat:flow-available', handleChatStatus)
  document.addEventListener('kundo-chat:flow-unavailable', handleChatStatus)
}

function titleAnchors(rootElement) {
  const article = rootElement.querySelector('article')
  const linkTitleContainer = rootElement.getElementById('link_title_container')

  if (!linkTitleContainer) { return }

  const linkTitle = linkTitleContainer.getAttribute('data-link-title')

  Array.prototype.forEach.call(article.querySelectorAll('h2,h3'), (elm) => {
    const slugPrefix = elm.innerText.replace(' ', '_').replace(/[^a-z0-9_]/ig, '')
    let slugSuffix = ''
    let count = 1

    while (rootElement.getElementById(slugPrefix + slugSuffix)) {
      count += 1
      slugSuffix = `-${count}`
    }
    const slug = slugPrefix + slugSuffix

    elm.setAttribute('id', slug)

    const link = document.createElement('a')
    link.setAttribute('href', `#${slug}`)
    link.classList.add('header-link')
    elm.setAttribute('title', linkTitle)
    link.innerHTML = elm.outerHTML

    elm.parentElement.replaceChild(link, elm)

    link.addEventListener('click', (event) => {
      link.scrollIntoView()
      document.location.hash = `#${slug}`
      event.preventDefault()
    })
  })

  window.addEventListener("hashchange", (event) => {
    const elm = rootElement.getElementById(document.location.hash.slice(1))
    if (elm!==null) {
      elm.scrollIntoView()
    }
  })

  if (document.location.hash) {
    const elm = rootElement.getElementById(document.location.hash.slice(1))
    if (elm!==null) {
      window.setTimeout(() => {
        elm.scrollIntoView()
      }, 500)
    }
  }
}

function getRootElement(document) {
  const K = window.KUNDO || {}
  const selector = K.placeholder || '#kundo-knowledge-embed'
  const placeholder = document.querySelector(selector)
  if (placeholder && placeholder.shadowRoot) {
    return placeholder.shadowRoot
  }
  return document
}

function customEvents(document) {
  const selectors = [
    '.contact-channels__channel-link',
    '.contact-channels-startpage-channel-list__channel-link'
  ].join(',')
  const contactChannels = document.querySelectorAll(selectors)
  if (contactChannels.length) {
    for (const contactChannel of contactChannels) {
      contactChannel.addEventListener('click', () => {
        const type = contactChannel.dataset.type
        document.dispatchEvent(
          new CustomEvent('kundo-knowledge:contact-channel-used', {
            detail: {type},
            bubbles: true,
            cancelable: true,
            composed: true,
          }),
        )
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = getRootElement(document)
  const isShadowRoot = root.ownerDocument !== null
  let fetchBaseUrl = ''
  if (isShadowRoot) {
    fetchBaseUrl = root.host.dataset.baseUrl
      ? root.host.dataset.baseUrl
      : window.location.origin
  }

  customEvents(root)
  searchForm(root)
  instantSearch(root, fetchBaseUrl)
  internetExplorerFixes(root)
  focusIndicator(root)
  voteButtons(root, fetchBaseUrl)

  lightboxModal(root)
  contactModal(root, fetchBaseUrl)

  if (root.querySelector('article')) {
    // will only run on a guide
    titleAnchors(root)
  }

  if (!isShadowRoot) {
    collapseSupportLinks()
    overflowedToplistLinks()

    if (document.querySelector('html').classList.contains('widget')) {
      widget()
    }

    kundoChat()
  }
})

document.dispatchEvent(
  new Event('kundo-knowledge:script-loaded', {
    bubbles: true,
    cancelable: true,
    composed: true,
  }),
)
